<script>
    import _ from 'lodash'
    import moment from 'moment'
    // import { mapGetters } from 'vuex'
    import OrgService from '@/request/user/org'
    import FollowupService from '@/request/followup/followup'
    export default {
        computed: {
            /* ...mapGetters('followup', {
                options: 'options',
                pagination: 'pagination'
            }) */
        },
        props: {
            showHeader: {
                type: Boolean,
                default: true
            },
            params: {
                type: Object,
                default() {
                    return {start: null, end: null, fail: null}
                }
            }
        },
        data () {
            return {
                tableHeaderCellStyle: {
                    padding: 0,
                    textAlign: 'center'
                },
                hospitals: [],
                chid: null,
                deptId: null,
                dnumbers: [],
                currentDate: null,
                listLoading: false,
                list: [],
                imgrid: null,
                visibleRecordImage: false,
                visibleEditRecord: false,
                currentFollowup: {},
                dateScope: [moment().startOf('day').valueOf(), moment().endOf('day').valueOf()],
                deptList: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick (picker) {
                            const end = moment().endOf('day').valueOf()
                            const start = end - 3600 * 1000 * 24 * 7
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '本月',
                        onClick (picker) {
                            const end = moment().endOf('day').valueOf()
                            const start = moment().startOf('month').valueOf()
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近一个月',
                        onClick (picker) {
                            const end = moment().endOf('day').valueOf()
                            const start = end - 3600 * 1000 * 24 * 30
                            picker.$emit('pick', [start, end])
                        }
                    }]
                },
                // findParams: {name: null, historySn: null, attendingName: null}
                options: {
                    hids: null,
                    start: null,
                    end: null,
                    name: null,
                    historySn: null,
                    attendingName: null,
                },
                pagination: {
                    sort: 'time',
                    order: 'ASC',
                    size: 10,
                    total: 0,
                    current: 1,
                    layout: 'total, sizes, prev, pager, next, jumper',
                    sizes: [10, 20, 30],
                },
                recovery: false,
            }
        },
        created: function () {
            this.recovery = this.recoveryState()
            this.chid = this.options.hids || null
            let start = this.options.start || moment().startOf('day').valueOf()
            let end = this.options.end || moment().endOf('day').valueOf()
            this.currentDate = end === moment(start).endOf('day').valueOf() ? start : null
            this.dateScope = [start, end]
            this.listHospital()
            this.createDateNumbers()
        },
        mounted: function () {},
        beforeDestroy: function () {},
        watch: {
            chid (val) {
                this.options.hids = val
                if (!this.recovery) this.pagination.current = 1
                this.listDept()
                this.listFollowup()
            },
            deptId() {
                this.listFollowup()
            },
            currentDate (nval, oval) {
                if (!nval) {
                    return
                }
                if (nval === oval) {
                    return
                }
                let start = moment(nval).startOf('day').valueOf()
                let end = moment(nval).endOf('day').valueOf()
                if (this.options.start === start && this.options.end === end) {
                    return
                }
                this.dateScope = [start, end]
            },
            dateScope (val) {
                let start = moment().startOf('day').valueOf()
                let end = moment().endOf('day').valueOf()
                if (!_.isEmpty(val)) {
                    start = val[0] ? moment(val[0]).startOf('day').valueOf() : start
                    end = val[1] ? moment(val[1]).endOf('day').valueOf() : end
                }
                this.currentDate = end === moment(start).endOf('day').valueOf() ? start : null
                _.assign(this.options, {
                    start: start,
                    end: end
                })
                if (!this.recovery) this.pagination.current = 1
                this.listFollowup()
            },
            params () {
                this.pagination.current = 1
                this.listFollowup()
            },
            /*'options' : {
                deep: true,
                handler () {
                    clearTimeout(this.timeout)
                    this.timeout = setTimeout(() => {
                        this.listFollowup()
                    }, 500)
                }
            }*/
        },
        methods: {
            // 保存当前状态
            saveState() {
                const state = JSON.stringify({'options': this.options, 'deptId': this.deptId, 'pagination': this.pagination})
                localStorage.setItem('followup_list_state', state)
            },
            // 恢复状态
            recoveryState() {
                const state = localStorage.getItem('followup_list_state')
                if (!state) return false
                const obj = JSON.parse(state)
                this.options = obj.options
                this.deptId = obj.deptId
                this.pagination = obj.pagination
                // 恢复后删除状态
                localStorage.removeItem('followup_list_state')
                return true
            },
            listHospital () {
                OrgService.listOrg({
                    parents: 1,
                    typeSns: 'lx0001001'
                }).then(res => {
                    this.hospitals = _.cloneDeep(res.result || [])
                    if (!_.isEmpty(this.hospitals) && !this.chid) {
                        this.chid = this.hospitals[0].id
                    }
                })
            },
            listDept() {
                this.deptList = []
                // this.deptId = null
                if (!this.chid) return
                OrgService.listOrg({
                    pids: this.chid,
                    typeSns: 'lx0001001001',
                }).then(res => {
                    this.deptList = res.result || []
                })
            },
            createDateNumbers () {
                const weeks = ['昨天', '今天', '昨天']
                let dns = []
                // let mid = _.floor(count / 2)
                for (let i = 0; i < 3; i++) {
                    let number = i - 1
                    let value = moment().add(number, 'd')
                    let name = weeks[value.day()]
                    switch (number) {
                        case 0:
                            name = '今天'
                            break
                        case 1:
                            name = '明天'
                            break
                        case -1:
                            name = '昨天'
                            break
                    }
                    dns.push({
                        value: value.startOf('day').valueOf(),
                        name: name
                    })
                }
                this.dnumbers = _.sortBy(dns, ['value'])
            },
            listFollowup () {
                if (!this.chid) {
                    return
                }
                if (!this.options.hids) {
                    this.options.hids = this.chid
                }
                this.options.oids = this.deptId || null
                this.listLoading = true
                let _options = {}
                if (this.params && !this.showHeader) {
                    _options = this.params
                } else {
                    _options = this.options
                }
                FollowupService.find(this.pagination, _options).then(res => {
                    let data = res.result
                    this.list = data.content || []
                    this.pagination.total = data.totalElements || 0
                }).finally(() => {
                    this.listLoading = false
                    this.recovery = false
                })
            },
            exportExcel () {
                console.log('下载文件')
                FollowupService.export(this.options)
            },
            handleSizeChange: function (val) {
                var self = this
                self.pagination.size = val
                self.pagination.current = 1
                self.listFollowup()
            },
            handleCurrentChange: function (val) {
                var self = this
                self.pagination.current = val
                self.listFollowup()
            },
            tableTimeFormatter (row, column, cellValue) {
                if (!cellValue) {
                    return ''
                }
                return moment(cellValue).format('MM-DD HH:mm')
            },
            tableDateFormatter (row, column, cellValue) {
                if (!cellValue) {
                    return ''
                }
                return moment(cellValue).format('YYYY-MM-DD')
            },
            tableStateFormatter (row, column, cellValue) {
                if (!cellValue) {
                    return '未随访'
                }
                let state = '未随访'
                if (row.state === 1) {
                    state = '已发送'
                }
                if (row.state === 2) {
                    state = '成功发送'
                }
                if (row.state === 3) {
                    state = '发送失败'
                }
                if (row.state === 4) {
                    state = '已回复'
                }
                if (row.state === 5) {
                    state = '已随访'
                }
                return state
            },
            tableFailureFormatter (row) {
                if (!row) {
                    return '未随访'
                }
                if (row.state !== 5) {
                    return '未随访'
                }
                let result = '良好'
                if (row.failure === 1) {
                    result = '不良'
                } else if (row.failure === 2) {
                    result = '无效'
                } else {
                    result = '良好'
                }
                return result
            },
            tableCellStyle (data) {
                let style = {
                    padding: 0
                }
                if (data.column.property === 'state') {
                    switch (data.row.state) {
                        case 1:
                            style.color = '#909399'
                            break
                        case 2:
                            style.color = '#409EFF'
                            break
                        case 3:
                            style.color = '#F56C6C'
                            break
                        case 4:
                            style.color = '#E6A23C'
                            break
                        case 5:
                            style.color = '#67C23A'
                            break
                    }
                    return style
                }
                if (data.column.property === 'failure') {
                    if (data.row.state === 5) {
                        if (data.row.failure === 2) {
                            style.color = '#cccccc'
                        } else if (data.row.failure === 1) {
                            style.color = '#F56C6C'
                        } else {
                            style.color = '#67C23A'
                        }
                    }
                    return style
                }
                return style
            },
            toRecord (followup) {
                if (!followup || !followup.diseaseRecordId) {
                    return
                }
                this.saveState()
                this.$router.push({name: 'record_show', params: {id: followup.diseaseRecordId}})
            },
            showRecordImages (followup) {
                if (!followup) {
                    return
                }
                if (!followup.diseaseRecordId) {
                    return
                }
                let hname = null
                _.forEach(this.hospitals, val => {
                    if (val.id === this.chid) {
                        hname = val.name
                    }
                })
                this.imgrid = {id: followup.diseaseRecordId, oid: followup.oid || this.chid, hid: this.chid, hname: hname}
                this.visibleRecordImage = true
            },
            showRecord (row) {
                if (!row) {
                    return
                }
                if (!this.$refs['followupTableRef']) {
                    return
                }
                this.$refs['followupTableRef'].toggleRowExpansion(row)
            },
            handleAddFollowupRecord (followup) {
                this.currentFollowup = _.cloneDeep(followup || {})
                this.visibleEditRecord = true
            },
            handleSaveRecordDone (record) {
                let recordListInstance = null
                this.visibleEditRecord = false
                if (!record) {
                    return
                }
                this.listFollowup(this.params)
                if (this.$refs['followupRecordList']) {
                    if (_.isArray(this.$refs['followupRecordList'])) {
                        for (let i = 0; i < this.$refs['followupRecordList'].length; i++) {
                            if (this.$refs['followupRecordList'][i].fuid === record.fuid) {
                                recordListInstance = this.$refs['followupRecordList'][i]
                                break
                            }
                        }
                    } else {
                        recordListInstance = this.$refs['followupRecordList']
                    }
                }
                if (recordListInstance) {
                    recordListInstance.listRollowupRecord()
                }
            }
        },
        filters: {}
    }
</script>

<template>
    <el-container>
        <el-header height="45px" v-if="showHeader" style="height: auto">
            <el-form :inline="true" class="demo-form-inline left-form" size="small">
                <el-form-item>
                    <el-select v-model="chid" placeholder="请选择医院" :disabled="hospitals.length <= 1">
                        <el-option
                                v-for="item in hospitals"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="deptId" placeholder="请选择科室" :disabled="deptList.length === 0" clearable>
                        <el-option label="全部科室" :value="null"></el-option>
                        <el-option
                                v-for="item in deptList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-radio-group v-model="currentDate">
                        <el-radio-button :label="dnumber.value" v-for="dnumber in dnumbers" :key="dnumber.value">
                            <span>{{dnumber.name}}</span>
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            style="width: 280px"
                            v-model="dateScope"
                            type="daterange"
                            format="yyyy年MM月dd日"
                            value-format="timestamp"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            range-separator="至"
                            :picker-options="pickerOptions"
                            clearable>
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 85px;" v-model="options.name" placeholder="患者姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 85px;"  v-model="options.historySn" placeholder="病历号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 85px;"  v-model="options.attendingName" placeholder="主治医生"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="listFollowup">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-form :inline="true" class="demo-form-inline right-form" size="small">
                <el-form-item>
                    <el-button type="primary" @click="$router.push({path: '/followup/count/' + chid})">随访统计</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="$router.push({path: '/followup/add/' + chid})">建立随访计划</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled="list.length === 0" @click="exportExcel">导出Excel</el-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="p20-scrollbar__view">
                <el-table
                        ref="followupTableRef"
                        v-loading="listLoading"
                        :data="list"
                        border
                        stripe
                        size="small"
                        :cell-style="tableCellStyle"
                        :header-cell-style="tableHeaderCellStyle"
                        style="width: 100%">
                    <el-table-column type="expand" width="40">
                        <template slot-scope="props">
                            <followup-record-list ref="followupRecordList" :fuid="props.row.id"></followup-record-list>
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" label="状态" width="60" :formatter="tableStateFormatter" align="center"></el-table-column>
                    <!--<el-table-column label="类型" prop="" width="70"></el-table-column>
                    <el-table-column label="科室"prop="" width="70"></el-table-column>-->
                    <el-table-column prop="failure" label="结果" width="60" :formatter="tableFailureFormatter" align="center"></el-table-column>
                    <el-table-column prop="historySn" label="病历号" width="100"></el-table-column>
                    <el-table-column prop="name" label="姓名" width="70"></el-table-column>
                    <el-table-column prop="sex" label="性别" width="50" align="center">
                        <template slot-scope="scope">
                            {{ !!scope.row.sex && scope.row.sex % 2 === 0 ? '女' : '男' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" label="年龄" width="50" align="center"></el-table-column>
                    <el-table-column prop="diseases" label="诊断"></el-table-column>
                    <el-table-column prop="treatment" label="术式"></el-table-column>
                    <el-table-column prop="num" label="次序" width="85" align="center">
                        <template slot-scope="scope">
                            <span>第{{scope.row.num}}次随访</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mobile" label="电话" width="100" align="center"></el-table-column>
                    <!--<el-table-column label="自动随访" width="70" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.auto === 1 ? '是' : '否' }}
                        </template>
                    </el-table-column>-->
                    <el-table-column prop="time" label="时间" width="85" :formatter="tableDateFormatter"></el-table-column>
                    <el-table-column label="操作" width="255">
                        <template slot-scope="scope">
                            <el-button size="small" type="text" @click="handleAddFollowupRecord(scope.row)">添加记录</el-button>
                            <el-button size="small" type="text" @click="showRecord(scope.row)" v-if="scope.row.recordCount > 0">查看记录</el-button>
                            <el-button size="small" type="text" @click="toRecord(scope.row)">查看病历</el-button>
                            <el-button size="small" type="text" @click="showRecordImages(scope.row)">查看图片</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
        </el-main>
        <el-footer height="35px">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.current" :page-sizes="pagination.sizes" :page-size="pagination.size" :layout="pagination.layout" :total="pagination.total"></el-pagination>
        </el-footer>
        <!-- 查看图片 -->
        <el-dialog title="图片" top="30px" :visible.sync="visibleRecordImage" @close="imgrid = {}" append-to-body>
            <record-record-image-list :record="imgrid" :enableAdd="false"></record-record-image-list>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visibleRecordImage = false">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 记录随访 -->
        <el-dialog title="随访" top="30px" :visible.sync="visibleEditRecord" @close="currentFollowup = {}" append-to-body>
            <followup-record-edit ref="recordEditRef" :followup="currentFollowup" @saveDone="handleSaveRecordDone"></followup-record-edit>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visibleEditRecord = false">取 消</el-button>
                <el-button type="primary" @click="$refs['recordEditRef'].save()">确定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*@media only screen and (max-width:1399px){
        .hidden-lg-and-down {
            display:none!important
        }
        .hidden-lg-and-up {
            display: block!important
        }
    }
    @media only screen and (min-width:1400px){
        .hidden-lg-and-up {
            display:none!important
        }
        .hidden-lg-and-down {
            display:block!important
        }
    }*/
</style>
